export default function (a, param) {
  // this.$format.options(data.Items);
  // this.$format.options(data.Items,{value: 'ID'});
  // this.$format.options(data.Items,{value: 'ID', label: 'NAME'});
  if (!a) a = []
  const p = param || {}
  const v = p.value ? p.value : 'Id'
  const l = p.label ? p.label : 'Name'

  // a это массив который приходит
  a.forEach((item) => {
    item.value = item[v]
    item.label = item[l]
  })
  return a
}
